<template>
	<div class="ReSearchMObjects">
		<tabs type="primary" 
			:activeTab="value"
			@change="OnTabChange"
            tabContentClasses="tab-opt"
            centered
            inline
            round	
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain mb-0 ">
            <tab-pane :id="'mobj'" >
				<template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-icons icon-components "></i><span>Плитка</span>
					</span>
                </template>
				<div class="row">
					<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>	
					<template v-if="value == 'mobj'">
						<ReSearchMObjSmall v-for="obj in masObjects" :key="obj.id" :objData="obj" />
					</template>
				</div>
            </tab-pane>

            <tab-pane :id="'lead'" class="lead">
                <template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-icons icon-align-left-2"></i><span>Список</span>
					</span>
                </template>

				<template>
					<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>
					<!-- <ReLeadTable v-if="value == 'lead'" :objData="masObjects" /> -->
					<ReLeadTableMyObj v-if="value == 'lead'" :objData="masObjects" />
				</template>	
            </tab-pane>
            <tab-pane :id="'objmap'" >
                <template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-icons icon-map-big"></i><span>Карта</span>
					</span>
                </template>
				<div class="card-wrapper">
					<div class="card-wrapper-center row px-3">
						<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>

						<ReSearchMObjMap v-if="value == 'objmap'" :objData="masObjects"/>
					</div>
				</div>
				<!-- <template>
					<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>
					<ReSearchMObjMap v-if="value == 'objmap'" :objData="masObjects"/>
				</template>	 -->
            </tab-pane>

        </tabs>
	</div>
</template>

<script>
	import { TabPane, Tabs } from 'src/components';
	import { Select, Option, Tooltip, Button } from 'element-ui';
	import ReSearchMObjSmall from 'src/our_modules/MarketingModule/ReSearchMObjSmall.vue';
	import ReSearchMObjMap from 'src/our_modules/MarketingModule/ReSearchMObjMap.vue';
	import ReLeadTableMyObj from 'src/our_components/ReLeadTableMyObj.vue';
	// import ReLeadTable from 'src/our_components/ReLeadTable.vue';

	export default {
		name: 'ReSearchMObjects',
		components: {
            TabPane, 
			Tabs,
			ReSearchMObjSmall,
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,	
			[Button.name]: Button,
			ReLeadTableMyObj,
			ReSearchMObjMap,
			// ReLeadTable,
			//Loading,

		},
		props: {
			masObjects: [Array,Object],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: String,
				default: 'mobj', // flats||flatmap
			}, 
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				// currentTab:'mobj',
				// localTab:'',
				// value:'mobj',
				// masAdSource: {
				// 	options: [
				// 		{value: '0',label: '1 - avito.ru',},
				// 		{value: '1',label: '2 - irr.ru',},
				// 		{value: '2',label: '3 - realty.yandex.ru',},
				// 		{value: '3',label: '4 - cian.ru',},
				// 		{value: '4',label: '5 - sob.ru',},
				// 		{value: '5',label: '6 - youla.io',},
				// 		{value: '6',label: '10 - moyareklama.ru',},
				// 	],
				// },
				/*
				bIsObject: this.IsObject(),
				bIsFlat: this.IsFlat(),
				bIsMap: this.IsMap(),*/
			}
		},
		computed: {

		},
		methods: {
			// setDefaultUrl(masDefaultParams){
			// 	let queryParams = new URLSearchParams('');
			// 	for (let i = 0; i < masDefaultParams.length; i++) {
			// 		queryParams.append(masDefaultParams[i][0],masDefaultParams[i][1]);
			// 	}
			// 	history.replaceState(null, null, "?"+queryParams.toString());
			// },
			// openFullScreen1(){
			// 	this.fullscreenLoading = true;
			// 	setTimeout(() => {
			// 	this.fullscreenLoading = false;
			// 	}, 2000);
			// },
			OnTabChange(strTabId){
				// if(this.currentTab == strTabId) return true;
				// this.currentTab = strTabId;

				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
				// this.openFullScreen1();
				// sessionStorage.setItem('localTab', this.currentTab);
				// //console.log(localStorage);
				// this.localTab = sessionStorage.getItem('localTab');
			// 	if(this.value=='mobj'){
			// 		let masDefaultParams = [];
			// 		masDefaultParams.push(['dSearchType','mobj']);
			// 		this.setDefaultUrl(masDefaultParams);
			// 	}
			// 	if(this.value=='lead'){
			// 		let masDefaultParams = [];
			// 		masDefaultParams.push(['dSearchType','lead']);
			// 		this.setDefaultUrl(masDefaultParams);
			// 	}
			// },
			},
			
		},
	}
</script>
<style scoped>
.ReSearchMObjects >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReSearchMObjects >>> .tab-content {margin-top: 15px;}
.ReSearchMObjects >>> .tab-space {padding-bottom: 0px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}



/*===media===============================*/
@media (max-width: 768px) {
	.flat .row {width: 100%; margin-left: 0px;}
}

</style>
